import { useLocation, useNavigate } from 'react-router';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import InfoContent from '../../components/InfoContent';
import { useEffect } from 'react';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const trial = query.get('trial');
  useEffect(() => {
    localStorage.removeItem('user');
  }, []);

  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <div className="flex flex-1 flex-col justify-center">
        {trial === 'false' && (
          <InfoContent
            icon={<GreenCheckIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
            title="Subscription Purchased"
            buttonLabel="Proceed to EHS Navigator"
            handleClick={() =>
              navigate(
                '/sign-in?message=Activation link sent—check your email to finish signing up.',
              )
            }
          />
        )}
        {trial === 'true' && (
          <InfoContent
            icon={<GreenCheckIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
            title="Free Trial Activated"
            buttonLabel="Proceed to EHS Navigator"
            handleClick={() =>
              navigate(
                '/sign-in?message=Activation link sent—check your email to finish signing up.',
              )
            }
          />
        )}
      </div>
    </main>
  );
}
